export default "__VITE_ASSET__d56a9bf9__"